import { PageInner, PageSection } from "@app/shared";
import { QESButton } from "@app/shared/qes-standards";
import { FC, JSX, useState,  } from "react";
import ProviderHubProvidersView from "./ProviderHubProvidersView";

type ProvidersTabViews = "Available" | "Targeted" | "Excluded";

const ProviderHubProvidersContainer: FC = (): JSX.Element => {

  const [activeTab, setActiveTab] = useState<ProvidersTabViews>("Available");

  return (
    <>
      <PageInner>
        <PageSection>
          <div className="tabs-style-2 mb-3">
            <ul className="nav nav-tabs" role="tablist">
              <li>
                <QESButton
                  qesType="none"
                  className={`nav-link text-dark font-weight-normal ${activeTab === "Available" ? "active disabled" : ""}`}
                  qesTestId="provider-hub___providers-tab-available"
                  onClick={() => setActiveTab("Available" as ProvidersTabViews)}
                  aria-disabled={activeTab === "Available"}
                  role="tab"
                >
                  Available
                </QESButton>
              </li>
              <li className="provider_hub__disabled-tab">
                <QESButton
                  disabled={true}
                  qesType="none"
                  className={`nav-link text-dark font-weight-normal ${activeTab === "Targeted" ? "active disabled" : ""}`}
                  qesTestId="provider-hub___providers-tab-targeted"
                  onClick={() => setActiveTab("Targeted" as ProvidersTabViews)}
                  aria-disabled={activeTab === "Targeted"}
                  role="tab"
                >
                  Targeted
                </QESButton>
              </li>
              <li className="provider_hub__disabled-tab">
                <QESButton
                  disabled={true}
                  qesType="none"
                  className={`nav-link text-dark font-weight-normal ${activeTab === "Excluded" ? "active disabled" : ""}`}
                  qesTestId="provider-hub___providers-tab-excluded"
                  onClick={() => setActiveTab("Excluded" as ProvidersTabViews)}
                  aria-disabled={activeTab === "Excluded"}
                  role="tab"
                >
                  Excluded
                </QESButton>
              </li>
            </ul>
          </div>
        </PageSection>

        {/* It would be ideal to reuse the ProviderHubProvidersView component and just pass a different prop according to the rendered tab. But it would be done in another WI as we advance with the Provider Hub development.
        So far, we are simply using the same component with the same configuration in the three tabs. */}
        {activeTab === "Available" &&
           <ProviderHubProvidersView/>
        }
        {activeTab === "Targeted" &&
          <ProviderHubProvidersView/>
        }
        {activeTab === "Excluded" &&
          <ProviderHubProvidersView/>
        }
      </PageInner>
    </>
  )
}

export default ProviderHubProvidersContainer;
